import React, { useState } from 'react';
import store, { templatesAction } from '@apply/adminStore';
import ActionSheet from 'devextreme-react/action-sheet';
import { InformModal } from '../../../common/SharedComponents';
import { TemplateActionType, TemplateType } from '@apply/constants';
import { TemplatesApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';
import { RefreshEvents } from '../../../common/SharedEvents';
import { ConfirmModal } from '@apply/ui';

export const ActionsButton = ({ data }) => {
    const { dispatch } = store;
    const templatesApi = new TemplatesApi.TemplatesApi(applicationInsights);
    const refreshEvents = new RefreshEvents();

    const [isConfirmOpen, set_isConfirmOpen] = useState(false);
    const [actionData, set_actionData] = useState({
        visible: false,
        target: null,
        items: [],
    });
    const [informModalOpen, set_informModalOpen] = useState(false);

    const deleteTemplate = async (templateId) => {
        var response = templatesApi.deleteTemplate(templateId);
        if ((await response).statusCode !== 200) {
            return;
        }
        refreshEvents.dispatchRefreshEvent();
    };

    const getActions = (template) => {
        const actions = [];

        actions.push({
            id: TemplateActionType.EditVersion,
            text: 'Edit',
            templateId: template.id,
        });

        actions.push({
            id: TemplateActionType.EditNotes,
            text: 'Notes',
            templateId: template.id,
            notes: template.notes,
        });

        if (template.templateTypeId === TemplateType.ICCA) {
            actions.push({
                id: TemplateActionType.EditName,
                text: 'Rename',
                templateId: template.id,
                name: template.name,
            });
        }

        if (template.canDelete) {
            actions.push({
                id: TemplateActionType.DeleteTemplate,
                text: 'Delete',
                type: 'danger',
                icon: 'remove',
                templateId: template.id,
            });
        }

        return actions;
    };

    const executeAction = (itemData) => {
        switch (itemData.id) {
            case TemplateActionType.EditVersion:
                dispatch(
                    templatesAction.setEditTemplateModal({
                        editTemplateModal: {
                            isOpen: true,
                            templateId: itemData.templateId,
                        },
                    })
                );
                break;
            case TemplateActionType.EditNotes:
                dispatch(
                    templatesAction.setEditNotesModal({
                        editNotesModal: {
                            isOpen: true,
                            templateId: itemData.templateId,
                            notesText: itemData.notes,
                        },
                    })
                );
                break;
            case TemplateActionType.EditName:
                dispatch(
                    templatesAction.setEditNameModal({
                        editNameModal: {
                            isOpen: true,
                            templateId: itemData.templateId,
                            nameText: itemData.name,
                        },
                    })
                );
                break;
            case TemplateActionType.DeleteTemplate:
                set_isConfirmOpen(true);
                break;
        }
    };

    const onActionClicked = (event, template) => {
        event.preventDefault();
        event.stopPropagation();

        const actions = getActions(template);

        if (actions.length === 0) {
            set_informModalOpen(true);
            return;
        }

        var data = {
            items: actions,
            target: `#${event.target.id}`,
            visible: true,
        };
        set_actionData(data);
    };

    const onActionItemClick = (e) => {
        set_actionData({ ...actionData, visible: false });
        executeAction(e.itemData, dispatch);
    };

    const onActionSheetVisibleChange = (isVisible) => {
        if (isVisible !== actionData?.visible) {
            set_actionData({ ...actionData, visible: isVisible });
        }
    };

    const onConfirmDelete = () => {
        deleteTemplate(data.id);
    };

    if (!data) {
        return null;
    }

    return (
        <>
            <button
                id={`action_${data.id}`}
                className='gridButton'
                title='Click to see options'
                onClick={(event) => onActionClicked(event, data)}
            >
                ...
            </button>
            <ActionSheet
                title='Choose action'
                usePopover={true}
                visible={actionData.visible}
                target={actionData.target}
                items={actionData.items}
                onItemClick={onActionItemClick}
                onVisibleChange={onActionSheetVisibleChange}
                showTitle={false}
            />
            <InformModal
                isOpen={informModalOpen}
                text={'No actions available'}
                confirmCallback={() => set_informModalOpen(false)}
            />
            <ConfirmModal
                isOpen={isConfirmOpen}
                text='Are you sure you wish to delete this template? This will not be reversible.'
                confirmCallback={onConfirmDelete}
                cancelCallback={() => set_isConfirmOpen(false)}
            />
        </>
    );
};
